// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__VarXs","content":"Header_content__yHZOv","title":"Header_title__3afS5","close-icon":"Header_close-icon__N44Rs"};